import React from 'react';
import { DataProviderInstance } from '../../../../api/DataProvider';
import { SendWhatsAppMessage } from '../../../../api/WhatsappAPI';
import MessagesTemplate from '../../../../consts/MessagesTemplate';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import PatientItem from '../shared/PatientItem';
import { ContactActions } from '../shared/IconAction';
import useSentFlag from '../../hooks/useSentFlag';
import RelationshipSection from './RelationshipSection';

function BirthdayItem({ item }) {
  const { CompanyConfig } = DataProviderInstance();
  const templates = MessagesTemplate.getTemplates(CompanyConfig);
  const [sent, markSent] = useSentFlag(`birthdayMsgSent-v2-${item.id}-${item.name}`);
  const hasPhone = item.phone && item.phone.length >= 8;

  function handleWhatsApp() {
    let message = templates.HappyBirthday || '';
    message = message.replaceAll('{name}', item.name.split(' ')[0]);
    message = message.replaceAll('{company_name}', CompanyConfig?.Name || '');
    SendWhatsAppMessage(item.phone, MessagesTemplate.ConvertToWhatsAppText(message), item.countryCode);
    markSent();
  }

  return (
    <PatientItem
      name={item.name}
      patientId={item.id}
      tone="pink"
      sent={sent}
      meta={`Faz ${item.age} anos hoje`}
      actions={hasPhone && <ContactActions whatsappTitle="Enviar parabéns" onWhatsApp={handleWhatsApp} phone={item.phone} />}
    />
  );
}

function BirthdaySection({ list }) {
  return (
    <RelationshipSection
      icon={<CakeOutlinedIcon style={{ fontSize: 16 }} />}
      tone="pink"
      title="Aniversariantes"
      hint="Um parabéns faz diferença"
      count={list.length}
    >
      {list.map((item, index) => <BirthdayItem key={item.id || index} item={item} />)}
    </RelationshipSection>
  );
}

export default BirthdaySection;
